import * as React from 'react';
import { Text, StackChildren, InlineChildren, Stack, } from '@doordash/design-language';
import track from '../../utils/track';
import { AdminPageSubpageContentContainer } from '../AdminPage/AdminPageStyles';
import Button from '@doordash/component-button';
import { ButtonContainer } from './DashPassStyles';
import DashPassSubscribedInfoSection from './DashPassSubscribedInfoSection';
import { DashpassSubscribedPage } from '../testId';
import { DashPassEvents } from '../../constants/events';
export var DashPassSubscribed = function () {
    React.useEffect(function () {
        track(DashPassEvents.SUBSCRIBED);
    }, []);
    var trackGetHelpClick = function () {
        return track(DashPassEvents.SUBSCRIBED_GET_HELP_CLICK);
    };
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(Stack, { size: Stack.Sizes.XLarge },
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildren.Alignment.Center },
                React.createElement(StackChildren, { size: StackChildren.Sizes.XxxSmall },
                    React.createElement(Text, { color: Text.Colors.TextPrimary, family: Text.Families.TtNorms, styles: Text.Styles.SectionTitleLarge, weight: Text.Weights.Medium }, "How to manage DashPass benefits"),
                    React.createElement(Text, { color: Text.Colors.TextSecondary }, "All employees added to this account will be eligible for DashPass benefits")),
                React.createElement(ButtonContainer, null,
                    React.createElement(Button, { type: Button.Types.Tertiary, isInline: true, size: Button.Sizes.Small, tag: "a", target: "_blank", href: 'https://help.doordash.com/work/s/topic/0TO2L0000001GHVWA2/dashpass-for-work', onClick: trackGetHelpClick, "data-testid": DashpassSubscribedPage.DashpassSubscribedPageGetHelp }, "Get Help")))),
        React.createElement(DashPassSubscribedInfoSection, null)));
};
export default DashPassSubscribed;
